import './style.scss'

type Props = {
  selectionIndex: number
  onClick?: () => void
}

export default function MapPolygonMarker({ selectionIndex, onClick }: Props) {
  return (
    <div onClick={onClick} className="cst-map-polygon-marker">
      {selectionIndex}
    </div>
  )
}
